import React from 'react';
import { MenuItem } from '../types';
import './PageNavigation.css';

interface PageNavigationProps {
  items: MenuItem[];
  onNavigate: (path: string) => void;
}

const PageNavigation: React.FC<PageNavigationProps> = ({ items, onNavigate }) => {
  return (
    <div className="page-navigation">
      {items.map((item) => (
        <div
          key={item.path}
          className={`nav-item ${item.active === true ? 'active' : ''}`}
          onClick={() => onNavigate(item.path)}
        >
          <span className={`nav-icon ${item.icon}`}></span>
          <span className="nav-label">{item.label}</span>
        </div>
      ))}
    </div>
  );
};

export default PageNavigation;
